import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { viewportOnce, EASE } from "@/lib/motion";
import { MANIFESTO, IMAGES } from "@/data/content";

const Manifesto = () => {
  return (
    <section
      id="philosophy"
      data-testid="philosophy-section"
      className="relative bg-forest text-ivory overflow-hidden grain scroll-mt-24"
    >
      <div
        className="absolute inset-0 opacity-[0.12] bg-cover bg-center"
        style={{ backgroundImage: "url('/images/manifesto-bg.png')" }}
        aria-hidden="true"
      />
      <div className="relative z-10 mx-auto max-w-[1600px] px-6 md:px-10 py-28 md:py-44">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-20 md:mb-28">
          <div className="lg:col-span-8 lg:col-start-1">
            <Reveal>
              <p className="kicker text-gold mb-8">Our manifesto</p>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="font-serif font-light text-4xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight">
                Three convictions that shape everything we do.
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="flex flex-col">
          {MANIFESTO.map((item, i) => (
            <motion.div
              key={item.number}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={viewportOnce}
              transition={{ duration: 1, ease: EASE }}
              className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 items-start py-12 md:py-16 border-t border-ivory/15 last:border-b"
            >
              <div className="lg:col-span-3">
                <span className="font-serif font-light text-gold text-7xl md:text-8xl lg:text-9xl leading-none">
                  {item.number}
                </span>
              </div>
              <div className="lg:col-span-4">
                <h3 className="font-serif font-light text-3xl md:text-4xl leading-tight">
                  {item.title}
                </h3>
              </div>
              <div className="lg:col-span-4 lg:col-start-9">
                <p className="text-ivory/70 leading-relaxed md:text-lg">{item.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
